import styled from "styled-components";

const ServicesSectionStyled = styled.section`
  height: 700px;
  margin-bottom: 30px;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 2650px;
     margin-top: 150px;
  }
  .h4 {
    color: ${({ theme }) => theme.color.red};
  }
  .services {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    row-gap: 20px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      row-gap: 40px;
      flex-direction: column;
    }
    .service {
      width: 33.3%;
      height: 160px;
      padding: 10px;
      display: flex;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: auto;
        /* margin-bottom: 20px; */
      }

      i {
        margin-right: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
        color: #ffffffff;
        background-color: blue;
        border-radius: 50%;
        border: 1px solid #ffffffff;
        transform: translateY(14px);
      }

      img {
        width: 60px;
        height: 60px;
        margin-right: 10px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          margin-right: 20px;
          width: 70px;
          height: 70px;
        }
      }

      .content {
        justify-content: space-between;
        flex-direction: column;
        display: flex;
        margin-bottom: 10px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            h4 {
            font-size: 1.3rem;
          }
        }
        p {
          font-size: 13px;
          margin-bottom: 10px;
          font-weight: 300;
          @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            font-size: 1rem;
            opacity: 0.7;
          }
        }
        a {
          text-decoration: none;
          font-weight: bold;
          font-size: 10px;
          letter-spacing: 1px;
          &:hover {
            text-decoration: underline;
            color: red;
          }
          @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            font-size: 1.2rem;
          }
        }
      }
    }
  }
  .service {
    width: 33.3%;
    display: table;

    i {
      margin-right: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 1px solid #000;
    }

    .content {
      display: table-cell;
      h4 {
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        margin-bottom: 10px;
      }
      a {
        text-decoration: none;
      }
    }
  }
`;

export { ServicesSectionStyled };
